"use client";
/*eslint-disable */
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

const TestimoniosComponent: React.FC = () => {
  return (
    <>
      <div className="testimonials-area ptb-100">
        <div className="container">
          <div className="section-title">
            <h2 className="nunito-font">Casos de éxito y testimonios</h2>
          </div>

          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div
                className="testimonials-image"
                data-aos="fade-up"
                data-aos-duration="800"
                data-aos-once="true"
              >
                <img
                  src="/iconos-3/testimonio_azul.svg"
                  alt="testimonials-image"
                  width={400}
                  height={400}
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="testimonials-content">
                <Swiper
                  slidesPerView={1}
                  spaceBetween={25}
                  pagination={{
                    clickable: true,
                  }}
                  modules={[Pagination]}
                  className="testimonials-slides-two"
                >
                  <SwiperSlide>
                    <div className="single-testimonials-box">
                      <i className="flaticon-left-quote"></i>
                      {/* <h5>“Gracias por su tiempo y asesoría”</h5> */}
                      <p>
                        Somos clientes de DISTRIBUIDORA ALIADOS hace más de 15
                        años. Nuestra fidelidad para tenerlos a ellos como uno
                        de nuestros proveedores se debe a la calidad de los
                        productos, a la velocidad en las entregas y siempre su
                        gran ánimo de servicio.
                      </p>
                      <div className="info">
                        <h3>PILAR</h3>
                        <span>EMPRESA DEL SECTOR AVÍCOLA</span>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="single-testimonials-box">
                      <i className="flaticon-left-quote"></i>
                      {/* <h5>“Every moment is a fresh beginning.”</h5> */}
                      <p>
                        En verdad, el servicio, la atención, la efectividad, los
                        precios en DISTRIBUIDORA ALIADOS, en especial el trato,
                        ha sido muy bueno y da alegría tener proveedores como
                        ustedes que se interesan por el buen trato y la
                        comodidad del cliente. En el tiempo que llevo, me ha ido
                        súper bien, ya que estoy a cargo de las compras y la
                        experiencia es gratificante.
                      </p>
                      <div className="info">
                        <h3>ESTEBAN</h3>
                        <span>EMPRESA DEL SECTOR OIL AND GAS</span>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="single-testimonials-box">
                      <i className="flaticon-left-quote"></i>
                      {/* <h5>“Whatever you do, do it well.”</h5> */}
                      <p>
                        Durante el tiempo que hemos trabajado en conjunto con
                        DISTRIBUIDORA ALIADOS, considero que ofrecen un
                        excelente servicio al cliente y siempre están dispuestos
                        a la mejora. Mantienen una buena calidad en el servicio
                        y son receptivos al atender cualquier solicitud.
                      </p>
                      <div className="info">
                        <h3>NANCY</h3>
                        <span>EMPRESA DEL SECTOR DE GESTIÓN DE RESIDUOS</span>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="single-testimonials-box">
                      <i className="flaticon-left-quote"></i>
                      {/* <h5>“Whatever you do, do it well.”</h5> */}
                      <p>
                        Durante más de 10 años hemos contado con la alianza de
                        nuestra empresa con DISTRIBUIDORA ALIADOS, recibiendo
                        atención y productos de primera calidad. Gracias a su
                        eficiencia en las entregas y su excelente servicio al
                        cliente, nos han contribuido al desarrollo de nuestra
                        actividad. Al igual, la buena calidad de sus químicos
                        nos ha permitido cumplir con los estándares y exigencias
                        de nuestros clientes. ¡Muchas gracias!
                      </p>
                      <div className="info">
                        <h3>ALEXANDRA</h3>
                        <span>
                          EMPRESA FABRICANTE DE PLANTAS DE TRATAMIENTO DE AGUA
                        </span>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="single-testimonials-box">
                      <i className="flaticon-left-quote"></i>
                      {/* <h5>“Whatever you do, do it well.”</h5> */}
                      <p>
                        DISTRIBUIDORA ALIADOS nos brinda una excelente atención,
                        sus asesores siempre están dispuestos a atender nuestros
                        requerimientos de manera oportuna y ágil. Poseen gran
                        disponibilidad de productos, buena distribución y
                        entrega.
                      </p>
                      <div className="info">
                        <h3>YURI</h3>
                        <span>EMPRESA DEL SECTOR METALMECANICO</span>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="single-testimonials-box">
                      <i className="flaticon-left-quote"></i>
                      {/* <h5>“Whatever you do, do it well.”</h5> */}
                      <p>
                        A la empresa DISTRIBUIDORA ALIADOS SAS queremos
                        felicitarlos porque representan a una organización que
                        lucha por la consecución de sus objetivos, el progreso y
                        el esfuerzo para alcanzar el éxito. Continúen motivados
                        dando cumplimiento y buen trato a sus clientes, ese es
                        su motor para hacer grande su proyecto como empresa.
                      </p>
                      <div className="info">
                        <h3>AUGUSTO</h3>
                        <span>
                          EMPRESA DE CONSULTORÍA EN MEDIO AMBIENTE Y TRATAMIENTO
                          DE AGUAS
                        </span>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="single-testimonials-box">
                      <i className="flaticon-left-quote"></i>
                      {/* <h5>“Whatever you do, do it well.”</h5> */}
                      <p>
                        Durante el último año hemos implementado un nuevo
                        sistema de etiquetado y de identificación de empaques en
                        productos líquidos y sólidos, mejorando
                        significativamente nuestra eficiencia y reduciendo los
                        riesgos de error. Este es un ejemplo de nuestro alto
                        compromiso con la seguridad y la eficiencia.
                      </p>
                      <div className="info">
                        <h3>CEO</h3>
                        <span>Distribuidora Aliados SAS</span>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="single-testimonials-box">
                      <i className="flaticon-left-quote"></i>
                      {/* <h5>“Whatever you do, do it well.”</h5> */}
                      <p>
                        Hemos logrado un hito importante en nuestra historia:
                        llegar a todo el país con nuestros productos de alta
                        calidad. Esto ha sido posible gracias a nuestras
                        alianzas estratégicas con líderes del sector, que nos
                        han permitido ampliar la cobertura para nuestros
                        clientes.
                      </p>
                      <div className="info">
                        <h3>CEO</h3>
                        <span>Distribuidora Aliados SAS</span>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="single-testimonials-box">
                      <i className="flaticon-left-quote"></i>
                      {/* <h5>“Whatever you do, do it well.”</h5> */}
                      <p>
                        "2024 un año de crecimiento y éxito" Con un rendimiento
                        comercial excepcional, vemos con gran felicidad que las
                        estrategias de innovación y satisfacción del cliente han
                        generado grandes resultados: 160 clientes nuevos en el
                        2024 con una tasa alta de recompra nos pone altos retos
                        para continuar y fortalecer nuestras estrategias.
                      </p>
                      <div className="info">
                        <h3>CEO</h3>
                        <span>Distribuidora Aliados SAS</span>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="single-testimonials-box">
                      <i className="flaticon-left-quote"></i>
                      {/* <h5>“Whatever you do, do it well.”</h5> */}
                      <p>
                        Durante el 2024 logramos un crecimiento significativo
                        del 12.5% en la cantidad de kilos que transportamos,
                        almacenamos y entregamos a nuestros clientes,
                        optimizando los residuos generados, implementando
                        tecnologías más eficientes y respetuosas del medio
                        ambiente, y fomentando prácticas sostenibles en nuestra
                        cadena de suministro.
                      </p>
                      <div className="info">
                        <h3>CEO</h3>
                        <span>Distribuidora Aliados SAS</span>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TestimoniosComponent;
